import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';

import { cn } from '../lib/utils';

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'group/checkbox peer h-4 w-4 shrink-0 cursor-pointer rounded-sm border border-muted-foreground/40 hover:border-muted-foreground/70 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-muted-foreground/40 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      {/* Radix mounts this Indicator for `indeterminate` as well as for `checked`, so the glyph
          has to be picked from the state — left alone, a partly-selected control renders the
          same check as a fully-selected one and reads as "all". Both glyphs are driven by the
          same `data-state` that fills the box above, so they cannot drift apart. */}
      <Check className="h-3.5 w-3.5 group-data-[state=indeterminate]/checkbox:hidden" />
      <Minus
        className="hidden h-3.5 w-3.5 group-data-[state=indeterminate]/checkbox:block"
        strokeWidth={3}
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
